/**
 * EXPO → Fuarlar. Projeler sayfasının fuar modu — sadece fuar projelerini
 * listeler; "Fuar To Do List" ile ülkeye göre otomatik şablonlu proje kurar.
 */
import Projects from "../Projects";

export default function ExpoFairProjects() {
  return (
    <div data-testid="expo-fair-projects-page">
      <Projects mode="fair" />
    </div>
  );
}
